export default __webpack_public_path__ + "static/inline-usage-example-1970bf234905ae4c356a747de20bfcd260b31a0fbfab6a3728317231e90578ce.png";